@if (items?.length) {
<div class="fx-row y-center fx-gap-md p-sm">
  <div>
    @if (selectEnabled && !isProduct) {
    <lc-checkbox class="m-0" label="SELECT ALL" [(ngModel)]="allSelected" (toggled)="toggleAll()" />
    }
  </div>

  @if (deleteEnabled && !isProduct) {
  <button class="text-faded" id="delete-selected-multimedia-items" mat-button [disabled]="noneSelected"
    (click)="deleteSelected()">
    <div class="fx-row x-center y-center fx-gap-xs">
      <mat-icon>delete</mat-icon>
      <span>Delete Selected</span>
    </div>
  </button>
  }
</div>

<!-- Table -->
<div class="scrollable-table-container mat-elevation-z1">
  <table mat-table [dataSource]="viewModels">

    <!-- Code column -->
    <ng-container matColumnDef="select">
      <th *matHeaderCellDef class="sticky-header" id="selection-header" mat-header-cell>Select</th>
      <td *matCellDef="let vm; let i = index" class="selection-cell" mat-cell>
        @if (!isProduct) {
        <lc-checkbox class="mr-2" [idPrefix]="'multimedia-title-' + i" [(ngModel)]="vm.isSelected"
          (toggled)="onSelectionChanged(i)" />
        }
        @if (isProduct && multiselect) {
        <lc-checkbox class="mr-2" [disabled]="isCheckboxDisabled(vm)" [idPrefix]="'multimedia-title-' + i"
          [ngModel]="vm.isSelected" (toggled)="onMouseClick(i)" />
        }
        @if (isProduct && !multiselect) {
        <label class="form-check-label mr-2" [class.no-label]="vm.item.title == null" [id]="i + '-mm-label'">
          <input class="mm-radio-button" type="radio" [checked]="vm.isSelected" [id]="i + '-mm-input'" [name]="name"
            (click)="onMouseClick(i)" />
        </label>
        }
      </td>
    </ng-container>

    <!-- Name column -->
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef class="sticky-header" id="name-header" mat-header-cell>Name</th>
      <td *matCellDef="let vm; let i = index" class="name-cell" mat-cell>
        {{vm.item.title}}
      </td>
    </ng-container>

    <!-- Link column -->
    <ng-container matColumnDef="link">
      <th *matHeaderCellDef class="sticky-header" id="link-header" mat-header-cell>Link</th>
      <td *matCellDef="let vm; let i = index" class="link-cell" mat-cell [class.truncate-url]="truncateUrl">
        <a target="new" [href]="vm.item.uri" [id]="'uri-multimedia-item-list-' + i"
          [title]="truncateUrl ? vm.item.uri : null">{{vm.item.uri}}</a>
      </td>
    </ng-container>

    <!-- Date column -->
    <ng-container matColumnDef="date">
      <th *matHeaderCellDef class="sticky-header" id="date-header" mat-header-cell>Date</th>
      <td *matCellDef="let vm; let i = index" class="date-cell" mat-cell>
        {{vm.item.audit.updatedAt | date: (hideDatetime ? 'MM/dd/yyyy' : 'MM/dd/yyyy HH:mm')}}
      </td>
    </ng-container>

    <!-- Agent column -->
    <ng-container matColumnDef="agent">
      <th *matHeaderCellDef class="sticky-header" id="agent-header" mat-header-cell>Uploaded By</th>
      <td *matCellDef="let vm; let i = index" class="agent-cell" mat-cell>
        {{vm.item.audit.updatedByFullName}}
      </td>
    </ng-container>

    <!-- Actions column -->
    <ng-container matColumnDef="actions">
      <th *matHeaderCellDef class="sticky-header" id="actions-header" mat-header-cell>Actions</th>
      <td *matCellDef="let vm; let i = index" class="actions-cell" mat-cell>
        @if (editEnabled && !isProduct) {
        <button class="xs edit-multimedia-item" color="default" mat-icon-button [id]="'edit-multimedia-item-list-' + i"
          (click)="open(edit, vm.item)">
          <mat-icon>edit</mat-icon>
        </button>
        }
      </td>
    </ng-container>

    <tr *matHeaderRowDef="rows" mat-header-row></tr>
    <tr *matRowDef="let vm; columns: rows;" mat-row></tr>
  </table>
</div>
}

<ng-template #edit>
  <lc-base-dialog id="edit-dialog" title="Edit" (actionClicked)="onCancel()">
    <ng-template #content>
      <lc-multi-media-item-form idPrefix="update" [formGroup]="formGroup" />
    </ng-template>

    <ng-template #actions>
      <div class="fx-row x-end fx-gap-xs">
        <button id="multimedia-cancel-button" lcTestId="multimedia-cancel-button" mat-raised-button type="button"
          (click)="onCancel()">Cancel</button>
        <button color="primary" id="multimedia-update-button" lcTestId="multimedia-update-button" mat-raised-button
          type="button" [disabled]="!formGroup.valid" (click)="doUpdate()">Update</button>
      </div>
    </ng-template>
  </lc-base-dialog>
</ng-template>